/*
 * @Author: Chao Yang
 * @Date: 2021-10-27 07:27:29
 * @LastEditor: Chao Yang
 * @LastEditTime: 2022-10-24 11:42:16
 */
import { Component, Input, OnInit } from '@angular/core';
import { DomSanitizer, SafeHtml } from '@angular/platform-browser';

@Component({
  selector: 'ad-video-viewer',
  templateUrl: './ad-video-viewer.component.html',
  styleUrls: ['./ad-video-viewer.component.scss']
})
export class AdVideoViewerComponent implements OnInit {
  html: SafeHtml;
  _videoUrl;
  @Input()
  set videoUrl(val) {
    this._videoUrl = val;
    let html = '';
    if (this.fileExtension === 'youtube') {
      var videoId = this._videoUrl;
      if (videoId !== null) {
        videoId = videoId.trim();
      }
      if (this._videoUrl.startsWith('https')) {
        const internalUrl = new URL(this._videoUrl);
        if (internalUrl.searchParams.has('v')) {
          videoId = internalUrl.searchParams.get('v');
        }
      }
      if (this._videoUrl.startsWith('watch')) {
        const internalUrl = new URL('https://www.youtube.com/' + this._videoUrl);
        if (internalUrl.searchParams.has('v')) {
          videoId = internalUrl.searchParams.get('v');
        }
      }

      html = `<div class="a-photoswipe-video-container"><iframe src="https://www.youtube.com/embed/${videoId}?enablejsapi=1&autoplay=1" frameborder="0" allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></iframe></div>`;
    } else if (this.fileExtension === 'vimeo') {

      var videoUrl = new URL('https://player.vimeo.com/');
      if (this._videoUrl !== null) {
        this._videoUrl = this._videoUrl.trim();
      }
      if (this._videoUrl.startsWith('https')) {
        const internalUrl = new URL(this._videoUrl);
        const [videoId, videoHash] = internalUrl.pathname.substring(1).split('/');

        videoUrl.pathname = `/video/${videoId}`;
        if (videoHash) {
          videoUrl.searchParams.append('h', videoHash);
        }
      } else {
        var pathname = this._videoUrl;

        // ensure the path does not start with bar when desconstruct the array.
        if (pathname.charAt(0) === '/') {
          pathname = pathname.substring(1);
        }

        const [videoId, videoHash] = pathname.split('/');

        videoUrl.pathname = `/video/${videoId}`;
        if (videoHash) {
          videoUrl.searchParams.append('h', videoHash);
        }
      }

      videoUrl.searchParams.append('autoplay', '1');
      html = `<div class="a-photoswipe-video-container"><iframe src="${videoUrl}" frameborder="0" allow="autoplay; fullscreen; picture-in-picture" allowfullscreen></iframe></div>`;
    }
    this.html = this.sanitizer.bypassSecurityTrustHtml(html);
  }
  @Input()
  fileExtension: string;

  get videoUrl() {
    return this._videoUrl;
  }

  constructor(private sanitizer: DomSanitizer) { }

  ngOnInit(): void {
    console.log(this.videoUrl);
  }

}
